import React, { useEffect, useRef, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import Navbar from "./Dashnav/Navbar";
import Header from "./Dashnav/Header";
import { Link, Route, useHistory } from "react-router-dom";
import { f, database, storage, auth } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import firebase from "firebase";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";
function Withdrawal() {
  const history = useHistory();
  const [dataready, setdataready] = useState(false);
  const [{ userdetails, loggedin, tradingpair }, dispatch] =
    useContext(GlobalContext);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  const [withdrawalMethod, setWithdrawalMethod] = useState("");
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    amount: "",
    wallet: "",
    b_name: "",
    a_type: "",
    a_number: "",
    b_pin: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleMethodChange = (e) => {
    setWithdrawalMethod(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      fname,
      lname,
      email,
      amount,
      wallet,
      b_name,
      a_type,
      a_number,
      b_pin,
    } = formData;

    if (!amount || !withdrawalMethod) {
      Swal.fire(
        "Missing Fields",
        "Please complete all required fields.",
        "warning"
      );
      return;
    }

    try {
      const user = firebase.auth().currentUser;
      if (!user) {
        Swal.fire(
          "Not Logged In",
          "You must be logged in to submit a withdrawal request.",
          "error"
        );
        return;
      }

      const userId = user.uid;

      const db = firebase.firestore();
      const userRef = db.collection("users").doc(userId);
      const userDoc = await userRef.get();

      if (!userDoc.exists) {
        Swal.fire("Error", "User not found in the database.", "error");
        return;
      }

      const userBalance = userDoc.data().balance || 0;
      const withdrawalAmount = parseFloat(amount);

      // Check if balance is sufficient
      if (withdrawalAmount > userBalance) {
        Swal.fire(
          "Insufficient Funds",
          "You do not have enough balance for this withdrawal.",
          "error"
        );
        return;
      }

      // Deduct the balance
      await userRef.update({
        balance: firebase.firestore.FieldValue.increment(-withdrawalAmount),
      });
      const userEmail = user.email; // Get the user's email
      const transactionData = {
        userId,
        userEmail,
        amount: withdrawalAmount,
        status: "Pending",
        type: "Withdrawal",
        date: firebase.firestore.FieldValue.serverTimestamp(),
        withdrawalMethod,
        ...((withdrawalMethod === "Bitcoin" || withdrawalMethod === "Ethereum"  || withdrawalMethod === "Usdt"  ||withdrawalMethod === "Xrp") && { wallet }),
        ...(withdrawalMethod === "Bank Transfer" && {
          bankDetails: {
            b_name,
            a_type,
            a_number,
            b_pin,
          },
        }),
      };

      // Add transaction to Firestore
      await db.collection("transactions").add(transactionData);

      // Update user's total withdrawals
      await userRef.update({
        Totalwithdrawal:
          firebase.firestore.FieldValue.increment(withdrawalAmount),
      });

      Swal.fire(
        "Success",
        "Withdrawal request submitted successfully!",
        "success"
      );

      // Reset the form
      setFormData({
        fname: "",
        lname: "",
        email: "",
        amount: "",
        wallet: "",
        b_name: "",
        a_type: "",
        a_number: "",
        b_pin: "",
      });

      await SendMailtoClient()
      await sendAdminMaiil()
      setWithdrawalMethod("");

      // Redirect to the /dashboards route
      history.push("/dashboards");
    } catch (error) {
      console.error("Error submitting withdrawal:", error);
      Swal.fire(
        "Error",
        "Error submitting withdrawal. Please try again.",
        "error"
      );
    }
  };




  const sendAdminMaiil = async () => {
    var templateParams = {
        message: `${userdetails.email} have successfully withdrawan  $${formData.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}  check admin dashboard to verify `,
    };

    await emailjs
        .send(
            "service_z6fxxig","template_ff4tnda",
            templateParams,
            "FE73KHuVHWMc2EeON"
        )
        .then(
            function (response) {
                // setloading(false)
            },
            function (err) {
                // setloading(false)
                // alert("FAILED...", err);
                console.log(err)
                
            }
        );
}

const SendMailtoClient = async () => {
    var templateParams = {
        to_name: userdetails.fullname,
        message:
            ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
           mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
           font-size: 14px;"><strong> You have requested withdrawal of the sum of $${formData.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} from your account .
           <br>your request have been recieved and is being processed.<br>
           Thanks for investing with us
          </strong>
          </div>`,

        user_email: userdetails.email,
        notification: "Withdrawal"
        // date: moment().format("MMM Do YY")
    };

    // setloading(false)
    emailjs
        .send(
            "service_7z7wtie",
            "template_nkt2bb2",
            templateParams,
            "9J9xbrUTOKeMOCJHy"
        )
        .then(
            function (response) {
                // setloading(false)


            },
            function (err) {
                emailjs
                    .send(
                        "service_jdi9txx",
                        "template_ros6t6e",
                        templateParams,
                        "s4YQNR2cFrf1HvS90"
                    )
                    .then(
                        function (response) {
                            // setloading(false)

                        },
                        function (err) {
                            // setloading(false)
                            
                            console.log(err)
                        }
                    );
                console.log(err)
            }
        );
}
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const {
  //     fname,
  //     lname,
  //     email,
  //     amount,
  //     wallet,
  //     b_name,
  //     a_type,
  //     a_number,
  //     b_pin,
  //   } = formData;

  //   if (!amount || !withdrawalMethod) {
  //     Swal.fire("Missing Fields", "Please complete all required fields.", "warning");
  //     return;
  //   }

  //   try {
  //     const user = firebase.auth().currentUser;
  //     if (!user) {
  //       Swal.fire("Not Logged In", "You must be logged in to submit a withdrawal request.", "error");
  //       return;
  //     }

  //     const userId = user.uid;

  //     const db = firebase.firestore();
  //     const userRef = db.collection("users").doc(userId);
  //     const userDoc = await userRef.get();

  //     if (!userDoc.exists) {
  //       Swal.fire("Error", "User not found in the database.", "error");
  //       return;
  //     }

  //     const userBalance = userDoc.data().balance || 0;
  //     const withdrawalAmount = parseFloat(amount);

  //     // Check if balance is sufficient
  //     if (withdrawalAmount > userBalance) {
  //       Swal.fire(
  //         "Insufficient Funds",
  //         "You do not have enough balance for this withdrawal.",
  //         "error"
  //       );
  //       return;
  //     }

  //     // Deduct the balance
  //     await userRef.update({
  //       balance: firebase.firestore.FieldValue.increment(-withdrawalAmount),
  //     });

  //     const transactionData = {
  //       userId,
  //       amount: withdrawalAmount,
  //       status: "Pending",
  //       type: "Withdrawal",
  //       date: firebase.firestore.FieldValue.serverTimestamp(),
  //       withdrawalMethod,
  //       ...(withdrawalMethod === "Bitcoin" && { wallet }),
  //       ...(withdrawalMethod === "Bank Transfer" && {
  //         bankDetails: {
  //           b_name,
  //           a_type,
  //           a_number,
  //           b_pin,
  //         },
  //       }),
  //     };

  //     // Add transaction to Firestore
  //     await db.collection("transactions").add(transactionData);

  //     // Update user's total withdrawals
  //     await userRef.update({
  //       Totalwithdrawal: firebase.firestore.FieldValue.increment(withdrawalAmount),
  //     });

  //     Swal.fire("Success", "Withdrawal request submitted successfully!", "success");

  //     // Reset the form
  //     setFormData({
  //       fname: "",
  //       lname: "",
  //       email: "",
  //       amount: "",
  //       wallet: "",
  //       b_name: "",
  //       a_type: "",
  //       a_number: "",
  //       b_pin: "",
  //     });
  //     setWithdrawalMethod("");
  //   } catch (error) {
  //     console.error("Error submitting withdrawal:", error);
  //     Swal.fire("Error", "Error submitting withdrawal. Please try again.", "error");
  //   }
  // };

  useEffect(() => {
    if (loggedin) {
      console.log(userdetails);
      console.log(userdetails.email);
      setLoading(false);
    } else {
      f.auth().onAuthStateChanged(function (user) {
        if (user) {
          var userid = f.auth().currentUser;
          var userids = userid.uid;
          fetchuserdata(userids);
          setloggedin(true);
        } else {
          setloggedin(false);
          setLoading(false);
          history("/");
        }
      });
    }
  }, []);

  const fetchuserdata = async (userid) => {
    var docRef = db.collection("users").doc(userid);
    const fetching = await docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          setdetails(doc.data());
          console.log(doc.data());
          setLoading(false);
          setdataready(true);
        } else {
          console.log("No such document!");
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  };

  const setdetails = (data) => {
    dispatch({ type: "setuserdetails", snippet: data });
  };

  const setloggedin = (data) => {
    dispatch({ type: "setloggedin", snippet: data });
  };

  const logout = async () => {
    const let1 = await setloggedin(false);
    const let2 = await f.auth().signOut();
    global.window && (global.window.location.href = "/home.html");
    const let3 = await history.push("/");
  };
  return (
    <div>
      <meta name="ROBOTS" content="NOINDEX, NOFOLLOW" />
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=0.75, shrink-to-fit=no"
      />
      <meta name="description" content />
      <meta name="author" content />
      <link rel="shortcut icon" href="img/favicon.png" type="image/x-icon" />
      {/* <title>TradingFxCapital | Dashboard</title> */}
      <link
        rel="stylesheet"
        href="vendor/font-awesome-4.7.0/css/font-awesome.min.css"
        type="text/css"
      />
      <link
        rel="stylesheet"
        href="vendor/bootstrap-4.1.1/css/bootstrap.css"
        type="text/css"
      />
      <link
        href="vendor/datatables/css/dataTables.bootstrap4.css"
        rel="stylesheet"
      />
      <link
        href="vendor/datatables/css/responsive.dataTables.min.css"
        rel="stylesheet"
      />
      <link
        href="vendor/jquery-jvectormap/jquery-jvectormap-2.0.3.css"
        rel="stylesheet"
      />
      <link rel="stylesheet" href="css/dark_grey_adminux.css" type="text/css" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
      />
      {/* g-hide */}
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n    iframe.goog-te-banner-frame {\n      display: none !important;\n    }\n  ",
        }}
      />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n    iframe.skiptranslate {\n      display: none !important;\n    }\n  ",
        }}
      />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n    body {\n      position: static !important;\n      top: 0px !important;\n    }\n  ",
        }}
      />
      {/* end-g-hide */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    div.alert {\n      padding: 4px 16px;\n      background: white;\n    }\n\n    input:text {\n      color: white;\n    }\n  ",
        }}
      />
      {/* /GetButton.io widget*/}
      {/* /GetButton.io widget */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    div.scrollmenu {\n      background-color: #333;\n      overflow: auto;\n      white-space: nowrap;\n    }\n\n    div.scrollmenu a {\n      display: inline-block;\n      color: white;\n      text-align: center;\n      padding: 14px;\n      text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n      background-color: #777;\n    }\n\n    table,\n    td {\n      background: black;\n      color: white;\n    }\n\n    th {\n      background: #00000088;\n      color: white;\n    }\n  ",
        }}
      />
      <header className="navbar-fixed">
        <nav className="navbar navbar-toggleable-md navbar-inverse bg-faded">
          {/* Header can be reused across pages */}
          <Header onToggleSidebar={toggleSidebar} />
          {/* Sidebar */}
          <Navbar isVisible={isSidebarVisible} activePage={"Withdraw"} />
          <div className="d-flex mr-auto"> &nbsp;</div>
          <div id="google_translate_element" style={{ marginBottom: '20px' }}></div>
          <div className="sidebar-right pull-right ">
            <ul className="navbar-nav  justify-content-end">
              <li className="nav-item">
                <button
                  className="btn-link btn userprofile"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                />
                <span className="userpic">
                  <img src="https://img.icons8.com/?size=80&id=108652&format=png" alt="user pic" />
                </span>{" "}
                <span className="text">offic</span>
              </li>
              <li>
                 <a onClick={logout}className="btn btn-link icon-header">
                  <span className="fa fa-power-off" />
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <div className="wrapper-content">
        <div className="container" style={{ maxWidth: "1300px" }}>
          {/* style="max-width:1400px" */}
          {/*<br><br> */}
          {/* <br> */}
          <title>TradingFxCapital | Withdrawal</title>
          <h1 style={{ textAlign: "center" }}>Make Withdrawal</h1>
          <div style={{ float: "center" }} className="row">
            <div className="col-sm-16 col-md-16">
              <div className="card">
                <div className="card-header">
                  <span>
                    <h3 style={{ color: "crimson", textAlign: "center" }} />
                  </span>
                </div>
                <form onSubmit={handleSubmit}>
  <div className="card-body">
    <div className="form-group row">
      <div className="col-8">
        <label htmlFor="fname">
          First Name <font color="crimson">*</font>
        </label>
        <input
          className="form-control"
          name="fname"
          type="text"
          value={formData.fname}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="col-8">
        <label htmlFor="lname">
          Last Name <font color="crimson">*</font>
        </label>
        <input
          className="form-control"
          name="lname"
          type="text"
          value={formData.lname}
          onChange={handleInputChange}
          required
        />
      </div>
    </div>

    <div className="form-group row">
      <div className="col-8">
        <label>
          Email Address <font color="crimson">*</font>
        </label>
        <input
          className="form-control"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="col-8">
        <label>
          Amount $ <font color="crimson">*</font>
        </label>
        <input
          className="form-control"
          type="number"
          name="amount"
          value={formData.amount}
          onChange={handleInputChange}
          min="1"
          required
        />
      </div>
    </div>

    <div className="form-group row">
      <label>
        Choose Withdrawal Method <font color="crimson">*</font>
      </label>
      <select
        className="form-control"
        value={withdrawalMethod}
        onChange={handleMethodChange}
        required
      >
        <option value="" disabled>
          Select Withdrawal Method
        </option>
        <option value="Bank Transfer">BANK TRANSFER</option>
        <option value="Bitcoin">BITCOIN</option>
        <option value="Ethereum">Ethereum</option>
        <option value="Usdt">Usdt</option>
        <option value="Xrp">Xrp</option>
      </select>
    </div>

    {(withdrawalMethod === "Bitcoin"|| withdrawalMethod === "Ethereum"  || withdrawalMethod === "Usdt"  ||withdrawalMethod === "Xrp" )  && (
      <div className="form-group row">
        <label>To Wallet Address</label>
        <input
          className="form-control"
          type="text"
          name="wallet"
          value={formData.wallet}
          onChange={handleInputChange}
          required
        />
      </div>
    )}

    {withdrawalMethod === "Bank Transfer" && (
      <div id="bank">
        <div className="form-group row">
          <label>Bank Name</label>
          <input
            className="form-control"
            type="text"
            name="b_name"
            value={formData.b_name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group row">
          <label>Bank Account Type</label>
          <input
            className="form-control"
            type="text"
            name="a_type"
            value={formData.a_type}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group row">
          <label>Account Number</label>
          <input
            className="form-control"
            type="text"
            name="a_number"
            value={formData.a_number}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group row">
          <label>Remote Pin / Routing Number</label>
          <input
            className="form-control"
            type="password"
            name="b_pin"
            value={formData.b_pin}
            onChange={handleInputChange}
            required
          />
        </div>
      </div>
    )}

    {/* Withdrawal Fee Notice */}
    {/* <div className="form-group row">
      <div className="col-16">
        <p style={{ color: 'crimson', fontWeight: 'bold', fontSize: '14px' }}>
          Please note: A 20% withdrawal fee will be applied to your transaction.
        </p>
      </div>
    </div> */}

    <div className="form-group row">
      <div className="col-16">
        <input
          className="btn btn-outline-primary"
          type="submit"
          value="WITHDRAW"
        />
      </div>
    </div>
  </div>
</form>

              </div>
              <a href="dashboards">
                <button style={{ float: "center" }} className="btn btn-primary">
                  back to account
                </button>
              </a>
            </div>
            <hr />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <div className="col-6">
                  <button
                    type="button"
                                       onClick={() => {
                      const walletAddress =
                        document.getElementById("referral_link").value;
                      navigator.clipboard
                        .writeText(walletAddress)
                        .then(() => {
                          Swal.fire({
                            icon: "success",
                            title: "Copied!",
                            text: "referral link copied to clipboard!",
                            timer: 2000,
                            showConfirmButton: false,
                          });
                        })
                        .catch(() => {
                          Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Failed to copy referral link.",
                            timer: 2000,
                            showConfirmButton: false,
                          });
                        });
                    }}
                    className="btn btn-primary"
                  >
                    Copy Referral Link
                  </button>
                </div>
                <div className="col-10">
                  <input
                    type="text"
                    style={{ color: "black" }}
                    className="form-control"
                    id="referral_link"
                      value={`https://www.finance-tellars.com/register.html?${userdetails.myReferralId}`}
                    readOnly
                  />
                </div>
              </div>
            </div>
            {/* TradingView Widget BEGIN */}
            <div className="tradingview-widget-container">
              <div className="tradingview-widget-container__widget" />
            </div>
            {/* TradingView Widget END */}
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n.mgm {\n    border-radius: 7px;\n    position: fixed;\n    z-index: 90;\n    bottom: 120px;\n    right: 20px;\n    background: #fff;\n    border:4px solid #3f48cc;\n    padding: 10px 27px;\n    box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, .3);\n}\n\n.mgm a {\n    font-weight: 700;\n    display: block;\n    color: #3f48cc;\n}\n\n.mgm a,\n.mgm a:active {\n    transition: all .2s ease;\n    color: #3f48cc;\n}\n",
              }}
            />
            <div className="mgm" style={{ display: "none" }}>
              <div className="txt" style={{ color: "black" }} />
            </div>
          </div>
        </div>
      </div>
      <div
        id="google_translate_element"
        style={{ visibility: "visible", display: "none" }}
      />
      {/* TradingView Widget BEGIN */}
      <div className="sidebar-right tradingview-widget-container ">
        <iframe
          allowTransparency="true"
          style={{ boxSizing: "border-box", height: "100%", width: "100%" }}
          src="https://www.tradingview-widget.com/embed-widget/screener/?locale=en#%7B%22width%22%3A%22220%22%2C%22height%22%3A600%2C%22defaultColumn%22%3A%22overview%22%2C%22defaultScreen%22%3A%22general%22%2C%22market%22%3A%22forex%22%2C%22showToolbar%22%3Afalse%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Afalse%2C%22enableScrolling%22%3Atrue%2C%22utm_source%22%3A%22marketstockspro.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22forexscreener%22%7D"
          frameBorder={0}
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    .tradingview-widget-copyright {\n      font-size: 13px !important;\n      line-height: 32px !important;\n      text-align: center !important;\n      vertical-align: middle !important;\n      font-family: 'Trebuchet MS', Arial, sans-serif !important;\n      color: #9db2bd !important;\n    }\n\n    .tradingview-widget-copyright .blue-text {\n      color: #2962FF !important;\n    }\n\n    .tradingview-widget-copyright a {\n      text-decoration: none !important;\n      color: #9db2bd !important;\n    }\n\n    .tradingview-widget-copyright a:visited {\n      color: #9db2bd !important;\n    }\n\n    .tradingview-widget-copyright a:hover .blue-text {\n      color: #1E53E5 !important;\n    }\n\n    .tradingview-widget-copyright a:active .blue-text {\n      color: #1848CC !important;\n    }\n\n    .tradingview-widget-copyright a:visited .blue-text {\n      color: #2962FF !important;\n    }\n  ",
          }}
        />
      </div>
      {/* TradingView Widget END */}
    </div>
  );
}

export default Withdrawal;
